<div class="report-web" *ngLet="dprDetails$ | async as dprDetails">
  <ng-container *ngIf="dprDetails; else invalidReportTemplate">
    <p *ngIf="shouldAddWatermark" class="watermark" i18n="@@report.reportContainer.txtIncomplete">Incomplete</p>

    <app-report-header [selectedSubproject]="selectedSubproject$ | async" [dprDetails]="dprDetails"></app-report-header>

    <ng-container *ngLet="projectSetup$ | async as projectSetup">
      <ng-container *ngFor="let item of reportTablesOrder" [ngSwitch]="item.reportOrderItemType">
        <app-report-hse
          *ngSwitchCase="reportOrderItemType.HSE"
          [hseList]="projectSetup.hseList"
          [dprHse]="dprDetails.dprHSE"
          [customNames]="projectSetup.subprojectConfiguration.customNames"
        ></app-report-hse>

        <app-report-weather
          *ngSwitchCase="reportOrderItemType.Weather"
          [weatherList]="projectSetup.weatherList"
          [weatherDataTypeValueList]="projectSetup.weatherDataTypeValueList"
          [dprWeather]="dprDetails.dprWeather"
          [customNames]="projectSetup.subprojectConfiguration.customNames"
        ></app-report-weather>

        <app-report-personnel
          *ngSwitchCase="reportOrderItemType.Personnel"
          [personnelList]="projectSetup.personnelList"
          [dprPersonnel]="dprDetails.dprPersonnel"
          [subprojectConfiguration]="projectSetup.subprojectConfiguration"
        ></app-report-personnel>

        <app-report-consumables
          *ngSwitchCase="reportOrderItemType.Consumables"
          [consumableList]="projectSetup.consumableList"
          [dprConsumable]="dprDetails.dprConsumable"
          [subprojectConfiguration]="projectSetup.subprojectConfiguration"
        ></app-report-consumables>

        <app-report-summary
          *ngSwitchCase="reportOrderItemType.Summary"
          [subprojectConfiguration]="projectSetup.subprojectConfiguration"
          [dprSummary]="dprDetails.dprSummary"
        ></app-report-summary>

        <ng-container *ngSwitchCase="reportOrderItemType.ForecastActivities">
          <app-report-forecast-activities
            *ngIf="projectSetup.subprojectConfiguration.enableForecast"
            [dprForecastActivities]="dprDetails.dprForecastActivities"
            [projectSetup]="projectSetup"
          ></app-report-forecast-activities>
        </ng-container>

        <ng-container *ngSwitchCase="reportOrderItemType.FreeTextFields">
          <ng-container
            *ngLet="getFreeTextFieldSubTabs(projectSetup.freeTextFields,item.identifier) as freeTextFieldSubTabs"
          >
            <app-report-free-text-fields
              *ngIf="freeTextFieldSubTabs?.length"
              [freeTextFieldSubTabs]="freeTextFieldSubTabs"
              [enableFreeTextFieldListLayout]="projectSetup.reportConfiguration.enableFreeTextFieldListLayout"
              [customName]="getFreeTextFieldCustomname(item.identifier)"
            ></app-report-free-text-fields>
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="reportOrderItemType.Progress">
          <app-report-progress
            *ngIf="projectSetup.subprojectConfiguration.enableProgressTab"
            [progress]="projectSetup.progress"
            [dprProgress]="dprDetails.dprProgress"
            [subprojectConfiguration]="projectSetup.subprojectConfiguration"
          ></app-report-progress>
        </ng-container>

        <ng-container *ngSwitchCase="reportOrderItemType.ProgressWithoutTarget">
          <app-report-progress-without-target
            *ngIf="projectSetup.subprojectConfiguration.enableProgressWithoutTargetTab"
            [progressWithoutTarget]="projectSetup.progressWithoutTarget"
            [dprProgressWithoutTarget]="dprDetails.dprProgressWithoutTarget"
            [subprojectConfiguration]="projectSetup.subprojectConfiguration"
          ></app-report-progress-without-target>
        </ng-container>

        <ng-container *ngSwitchCase="reportOrderItemType.TableOfColumns">
          <ng-container *ngLet="getTableOfColumnWithData(item.identifier) as tableOfColumn">
            <app-report-table-of-columns
              *ngIf="tableOfColumn?.tableOfColumnItems?.length"
              [tableOfColumnItemDataTypeValueList]="getTableOfColumnItemDataTypeValueList(tableOfColumn)"
              [tableOfColumnItems]="tableOfColumn.tableOfColumnItems"
              [dprTableOfColumns]="getTableOfColumn(item.identifier)"
              [isSummaryEnabled]="getTableOfColumnSummaryEnabled(tableOfColumn)"
              [summaryLabel]="tableOfColumn?.summaryLabel"
              [customName]="tableOfColumn?.name"
            ></app-report-table-of-columns>
          </ng-container>
        </ng-container>

        <app-report-online-approvals
          *ngSwitchCase="reportOrderItemType.ApprovalDetails"
          [onlineApproverList]="projectSetup.onlineApproverList"
          [dprOnlineApprovals]="dprDetails.dprOnlineApprovals"
          [customNames]="projectSetup.subprojectConfiguration.customNames"
        ></app-report-online-approvals>

        <app-report-print-signatures
          *ngSwitchCase="reportOrderItemType.Signatures"
          [approverList]="projectSetup.approverList"
          [dprApprovers]="dprDetails.dprApprovers"
        ></app-report-print-signatures>

        <ng-container *ngIf="projectSetup.subprojectConfiguration.enableStatusTrackerTab">
          <ng-container *ngFor="let statusTrackerItem of (statusTrackerModel$ | async)">
            <app-report-status-tracker
              *ngSwitchCase="reportOrderItemType.StatusTracker"
              [dprStatusTrackerModelReport]="statusTrackerItem"
              [customNames]="projectSetup.subprojectConfiguration.customNames"
            ></app-report-status-tracker>
          </ng-container>
        </ng-container>

        <app-report-activities
          *ngSwitchCase="reportOrderItemType.Activities"
          [activitiesModel]="activitiesModel$ | async"
          [activityType]="item.identifier"
          [subprojectConfiguration]="projectSetup.subprojectConfiguration"
        ></app-report-activities>

        <app-report-log-of-events
          *ngSwitchCase="reportOrderItemType.LogEvents"
          [reportLogOfEvents]="reportLogOfEvents$ | async"
          [enableEventsLogActivityGroupsOnly]="enableEventsLogActivityGroupsOnly"
        ></app-report-log-of-events>
      </ng-container>

      <div *ngIf="projectSetup.namingConvention?.includeNameInReport">
        <br />
        <div *ngIf="isRenameReportFileEnabled; else defaultFilenameTemplate">
          <p>{{customFilename}}</p>
        </div>
        <ng-template #defaultFilenameTemplate>
          <p>{{defaultFilename}}</p>
        </ng-template>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #invalidReportTemplate>
    <span i18n="@@report.reportContainer.txtInvalidDprDetails">Invalid DPR Details</span>
  </ng-template>
</div>
